/* Feedback page — behaviour for sections/feedback-survey.liquid (/pages/feedback „Deine Meinung“, 26 Oct 2026;
   stepper FB-v2 the same day). Plan: planning/crm-klaviyo-2026-10/build/flow-review-2026-10-26/SURVEY-PLAN.md §3,
   survey-questions.md §2–3; v1 notes: planning/crm-klaviyo-2026-10/build/v3-1-2026-10-26/FEEDBACK-PAGE.md; stepper
   notes and tests: planning/crm-klaviyo-2026-10/build/flow-review-2026-10-26/feedback-page-v2/BUILD.md; partial
   saves FB-v3 (28 Oct), the binding event contract: planning/crm-klaviyo-2026-10/build/adt11-12-13a-1028/CONTRACT-FB-v3.md

   Link: /pages/feedback?s=<0–10>&src=<touchpoint>#k=<Klaviyo profile id>&o=<order reference>
   - layout/theme.liquid has already moved the fragment (and a Klaviyo _kx query value, if a link carries one) out of
     the address bar into history.state, before Shopify's analytics and the pixels read the URL. A reload keeps
     history.state, so the page still knows who answers. Every history entry this script adds copies that state.
   - Validation: s = integer 0–10, src from the section's list, k = 26 letters/digits (Klaviyo profile id), o = order
     reference without „#“ (else empty). No k and no _kx, or an unknown src → the thank-you without a form.
   - Stepper (founder 26 Oct): one question per screen. A valid s means the 0–10 question is not on the way forward
     (answered in the mail); without s it comes first. Long form = intro screen + questions, short form (t3/t4b) = the
     text question only. A tap answer moves on after ADVANCE_MS; arrow keys only move the choice, Enter or „Weiter“
     moves on (ratings: „Weiter“ from the first row set, on by itself once all three are). Every question can be
     skipped (its answer is cleared; on the short form's one question an empty „Abschicken“ is the skip). „Zurück“
     (top row, left of the count, since 29 Oct) and the browser's back button go one question back and keep the
     answers: each question gets a history entry with the same URL (no new URL parts). With s, „Zurück“ on the first
     question of the long form opens the 0–10 question with the link's score chosen (founder 29 Oct, see npsBack).
   - Events: Klaviyo client API (POST a.klaviyo.com/client/events/?company_id=<public site id>, revision header), metric
     from the section (addit_feedback). Stage „score“ (setting: once the page has been on screen for DWELL_MS without
     signs of automation, else at the first tap/key press („visible“, 30 Oct: the mail's number counts even if the tab
     is closed right away); at the first tap/key press; on load; or off. Without s it goes out when the visitor moves
     on from the 0–10 question with an answer; a failed one goes out again before the next send or when the page is
     hidden; the event says what made it due: trigger load | tap, visible_ms), stage „partial“ (FB-v3: the answers so
     far, see sendPartial) and stage „complete“ once at the
     end with all answers. Nothing is sent after „complete“. unique_id = <response_id>:<stage>, response_id =
     src.profile.(order or month).score from the link, so a reload, a second tab or a double tap never writes an
     answer twice (Klaviyo keeps the first event per profile, metric and unique_id); a partial has its own
     <response_id>:partial:<visit_id>:<seq>, so every snapshot is kept. Event name and property names are those of
     FB-v1 (bq-schema.sql reads them) plus visit_id, seq, answered_count, partial_reason, last_step and (29 Oct)
     reorder_barriers_other, the „Was genau?“ field under „Etwas anderes“; form_version says FB-v3.
   - Thank-you (30 Oct): the review ask (data-fb-review, rendered hidden) is shown for every score, never gated by
     it; it stays hidden for the src values in data-review-hide-sources (section setting, default t3,t4b: the
     delivery mails, where the buyer has not used addit yet; ADT 40 asks at ~D+5).
   - PREVIEW / DRY RUN (see dryRun below): nothing leaves the page, the flow and the thank-you behave as usual, the
     payloads go to the console and to window.__additFeedbackDryRun.
   - Privacy: no cookies (credentials: 'omit'), no localStorage/sessionStorage, only the origin as referrer, no
     third-party script. The answers live in the form inputs only; visit_id, seq and the last snapshot sent in
     memory only. Text typed in the last question but not sent goes into a partial only with the section setting
     „save_unsent_text“ (default off); „Wofür sonst?“ and „Was genau?“ only once confirmed with Weiter.
   Plain ES5 plus fetch (like the other theme scripts). */
(function () {
  'use strict';

  var ENDPOINT = 'https://a.klaviyo.com/client/events/?company_id=';
  var FIELDS_TEXT_MAX = { uses_other: 100, reorder_barriers_other: 200, improve_text: 1000 };
  var ADVANCE_MS = 250; // a tapped answer stays visible this long before the next question
  var PREVIEW_K = 'preview'; // #k=preview → dry run, on any theme
  // Score setting „visible“ (30 Oct): the page must have been on screen this long (a real tab in front, not a background
  // tab or a prerender) before the mail's score counts without a tap
  var DWELL_MS = 1000;
  // User agents of headless browsers and crawlers: there the score waits for a tap, as before
  var AUTOMATION_UA = /HeadlessChrome|PhantomJS|Lighthouse|Googlebot|bingbot|AdsBot|YandexBot|crawler|spider/i;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function csv(s) {
    return String(s || '').toLowerCase().split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  }
  function has(obj, key) { return Object.prototype.hasOwnProperty.call(obj, key); }
  function rand36(n) {
    var s = '';
    while (s.length < n) s += Math.floor(Math.random() * 36).toString(36);
    return s;
  }

  function readLink() {
    var q = {};
    try {
      new URLSearchParams(window.location.search).forEach(function (v, key) { q[key] = v; });
    } catch (e) {}
    var saved = null;
    try { saved = window.history.state && window.history.state.adtFb; } catch (e) {}
    var frag = window.location.hash ? window.location.hash.slice(1) : '';
    if (!frag && saved && saved.h) frag = saved.h;
    var f = {};
    frag.split('&').forEach(function (part) {
      if (!part) return;
      var i = part.indexOf('=');
      var key = (i === -1 ? part : part.slice(0, i)).toLowerCase();
      var val = i === -1 ? '' : part.slice(i + 1);
      try { val = decodeURIComponent(val.replace(/\+/g, ' ')); } catch (e) {}
      if (!has(f, key)) f[key] = val;
    });
    return { q: q, f: f, kx: q._kx || (saved && saved.kx) || '' };
  }

  function month() {
    try {
      return new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit' })
        .format(new Date()).slice(0, 7);
    } catch (e) {
      var d = new Date();
      return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2);
    }
  }

  // Shopify prints Shopify.theme (with role "main" for the live theme) in content_for_header on every storefront page
  function onUnpublishedTheme() {
    try {
      var t = window.Shopify && window.Shopify.theme;
      return !!(t && t.role && t.role !== 'main');
    } catch (e) { return false; }
  }

  // A browser driven by a program (some mail security scanners open links in one): navigator.webdriver is true under
  // WebDriver, Playwright and Puppeteer unless the scanner hides it, and headless or crawler user agents name
  // themselves. A real phone or desktop browser shows neither. In doubt: automated (the score then waits for a tap).
  function automated() {
    try {
      if (window.navigator.webdriver === true) return true;
      return AUTOMATION_UA.test(String(window.navigator.userAgent || ''));
    } catch (e) { return true; }
  }
  // On screen: the tab is in front and the page is not a prerender (Speculation Rules) that nobody has opened yet
  function onScreen() {
    try { return document.visibilityState === 'visible' && !document.prerendering; } catch (e) { return false; }
  }

  function init(root) {
    if (!root || root.getAttribute('data-fb-ready') === '1') return;
    root.setAttribute('data-fb-ready', '1');

    var cfg = {
      company: (root.getAttribute('data-company-id') || '').trim(),
      metric: root.getAttribute('data-metric') || 'addit_feedback',
      revision: root.getAttribute('data-revision') || '2026-10-15',
      sources: csv(root.getAttribute('data-sources')),
      shortSources: csv(root.getAttribute('data-short-sources')),
      reviewHide: csv(root.getAttribute('data-review-hide-sources')), // src values without the review ask (t3,t4b)
      scoreEvent: root.getAttribute('data-score-event') || 'interaction',
      formVersion: root.getAttribute('data-form-version') || 'FB-v3',
      saveText: root.getAttribute('data-save-unsent-text') === '1' // improve_text in a partial (default off)
    };
    var form = root.querySelector('[data-fb-form]');
    var t0 = Date.now();
    var visitId = t0.toString(36) + '-' + rand36(4); // one per page load, in memory only (partial unique_id)
    // Visibility clock (30 Oct): how long the page has been on screen since the script started (visible_ms, DWELL_MS)
    var visTotal = 0;
    var visSince = onScreen() ? t0 : 0;
    function visibleMs() { return visTotal + (visSince ? Date.now() - visSince : 0); }
    function visTick() {
      var now = Date.now();
      if (visSince) { visTotal += now - visSince; visSince = 0; }
      if (onScreen()) visSince = now;
    }

    function show(name) {
      each(root.querySelectorAll('[data-fb-state]'), function (el) {
        el.hidden = el.getAttribute('data-fb-state') !== name;
      });
    }
    function focusEl(el) {
      if (!el) return;
      try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
    }
    function toTop() {
      var top = root.getBoundingClientRect().top + window.pageYOffset;
      if (window.pageYOffset <= top + 1) return;
      try { window.scrollTo({ top: top, left: 0, behavior: 'instant' }); } catch (e) { window.scrollTo(0, top); }
    }
    // The band fills the screen under the header: --fb-offset = how far the section starts from the page top
    function setOffset() {
      var top = root.getBoundingClientRect().top + window.pageYOffset;
      var cap = (window.innerHeight || 800) * 0.4;
      root.style.setProperty('--fb-offset', Math.round(Math.max(0, Math.min(top, cap))) + 'px');
    }

    // ---------------------------------------------------------------- link
    var link = readLink();
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var sRaw = link.q.s || '';
    var score = /^(10|[0-9])$/.test(sRaw) ? parseInt(sRaw, 10) : null;
    var src = String(link.q.src || '').toLowerCase();
    var kRaw = String(link.f.k || '');
    var k = /^[0-9A-Za-z]{26}$/.test(kRaw) ? kRaw : '';
    var kx = /^[A-Za-z0-9._~=+\/-]{8,400}$/.test(link.kx || '') ? link.kx : '';
    var order = String(link.f.o || '').replace(/^(#|%23)+/i, '').trim();
    if (!/^[A-Za-z0-9._-]{1,40}$/.test(order)) order = '';

    // ---------------------------------------------------------------- PREVIEW / DRY RUN
    // Nothing is sent to anyone in any of these cases; send() below returns before fetch. Safe on the live theme.
    var dryRun =
      kRaw.toLowerCase() === PREVIEW_K ||           // #k=preview — the founder's preview link, any theme
      has(link.f, 'demo') ||                         // #demo (FB-v1 name)
      designMode ||                                  // Shopify theme editor
      root.getAttribute('data-dry-run') === '1' ||   // static preview file (the Liquid never prints this attribute)
      (!k && !kx && onUnpublishedTheme());           // no profile in the link on an unpublished theme (preview_theme_id)
    if (dryRun && !src) src = 'adt12';
    var dryLog = null;
    if (dryRun) dryLog = window.__additFeedbackDryRun = window.__additFeedbackDryRun || [];
    if (dryRun) root.querySelector('[data-fb-demo]').hidden = false; // also on „Danke für dein Interesse.“ (allowlist check)

    if (!form || cfg.sources.indexOf(src) === -1 || (!dryRun && (!cfg.company || (!k && !kx)))) {
      show('noid');
      window.__additFeedbackReady = true; // the fallback timer in the section stays quiet
      return;
    }

    var isShort = cfg.shortSources.indexOf(src) !== -1;
    // Review ask on the thank-you (30 Oct): decided by src alone, the same for every score (no gating)
    var review = root.querySelector('[data-fb-review]');
    if (review) review.hidden = cfg.reviewHide.indexOf(src) !== -1;
    var scored = score !== null;
    // With s (long form): the 0–10 question is not on the way forward, but „Zurück“ on the first question (and the
    // browser's back there) opens it with the link's score chosen, so the mail score can be corrected. A changed score
    // goes into partial and complete as nps, with nps_from_link the link's; the score event and response_id keep the
    // link's score (no second score event).
    var npsBack = scored && !isShort;
    var who = k || (kx ? 'kx' + kx.replace(/[^A-Za-z0-9]/g, '').slice(0, 24) : PREVIEW_K);
    var responseId = [src, who, order || month(), scored ? 's' + score : 'sx'].join('.');

    // ---------------------------------------------------------------- elements, texts
    var lead = form.querySelector('[data-fb-lead]');
    var heading = form.querySelector('[data-fb-heading]');
    var intro = form.querySelector('[data-fb-intro]');
    var nextBtn = form.querySelector('[data-fb-next]');
    var prevBtn = root.querySelector('[data-fb-prev]'); // in the top row, outside the form (29 Oct)
    var skipBtn = form.querySelector('[data-fb-skip]');
    var nav = form.querySelector('[data-fb-nav]');
    var privacy = form.querySelector('[data-fb-privacy]');
    var errorBox = form.querySelector('[data-fb-error]');
    var count = root.querySelector('[data-fb-count]');
    var track = root.querySelector('[data-fb-track]');
    var bar = root.querySelector('[data-fb-bar]');
    var pattern = (count && count.getAttribute('data-pattern')) || '[i] von [n]';

    heading.textContent = heading.getAttribute(scored ? 'data-scored' : 'data-unscored');
    intro.textContent = intro.getAttribute(scored ? 'data-scored' : 'data-unscored');
    if (isShort) {
      root.classList.add('fb--short');
      intro.hidden = true;
      var textLabel = form.querySelector('[data-fb-text-label]');
      textLabel.textContent = textLabel.getAttribute('data-short');
      form.querySelector('textarea[name="improve_text"]').removeAttribute('placeholder');
    }

    function values(name) {
      var out = [];
      each(form.querySelectorAll('input[name="' + name + '"]:checked'), function (el) { out.push(el.value); });
      return out;
    }
    function one(name) { var v = values(name); return v.length ? v[0] : null; }
    function text(name) {
      var el = form.querySelector('[name="' + name + '"]');
      if (!el) return '';
      return el.value.replace(/\r\n?/g, '\n').replace(/\n{3,}/g, '\n\n').trim().slice(0, FIELDS_TEXT_MAX[name] || 200);
    }

    // ---------------------------------------------------------------- steps
    // steps[0] is the intro screen (its content is the lead); the rest are the [data-fb-step] blocks in page order.
    var steps = [{ name: 'intro', el: lead, auto: '' }];
    each(form.querySelectorAll('[data-fb-step]'), function (el) {
      steps.push({ name: el.getAttribute('data-fb-step'), el: el, auto: el.getAttribute('data-fb-auto') || '' });
    });
    function indexOf(name) {
      for (var i = 0; i < steps.length; i++) if (steps[i].name === name) return i;
      return -1;
    }
    // Is the step on the page for this link at all? (fixed for the visit; the numbering uses it)
    function exists(name) {
      if (name === 'intro') return !isShort;
      if (name === 'nps') return !scored; // with s: not on the way forward and not numbered (only back, see npsBack)
      if (name === 'improve_text') return true;
      return !isShort;
    }
    // Is it shown, given the answers so far? back: on the way back, where the 0–10 question with s is reachable too
    function applies(i, back) {
      var name = steps[i].name;
      if (name === 'nps' && npsBack) return !!back;
      if (!exists(name)) return false;
      if (name === 'frequency' || name === 'ratings') return values('uses').indexOf('noch_nicht') === -1;
      if (name === 'reorder_barriers') {
        var it = one('reorder_intent');
        return !!it && it !== 'ja_sicher';
      }
      return true;
    }
    // „2 von 5“: every question that exists for this link; „Was hält dich ab?“ belongs to „Kaufst du addit nach …?“.
    // Skipped questions keep their numbers, so the count jumps ahead rather than changing its total.
    var numbered = [];
    steps.forEach(function (s) {
      if (s.name !== 'intro' && s.name !== 'reorder_barriers' && exists(s.name)) numbered.push(s.name);
    });
    function number(name) { return numbered.indexOf(name === 'reorder_barriers' ? 'reorder_intent' : name) + 1; }
    function nextFrom(i) { for (var j = i + 1; j < steps.length; j++) if (applies(j)) return j; return -1; }
    function prevFrom(i) { for (var j = i - 1; j >= 0; j--) if (applies(j, true)) return j; return -1; }

    function answered(s) {
      if (!s || !s.el || s.name === 'intro') return false;
      if (s.auto === 'all') {
        var groups = {};
        each(s.el.querySelectorAll('input[type="radio"]'), function (el) { groups[el.name] = groups[el.name] || el.checked; });
        for (var g in groups) if (has(groups, g) && !groups[g]) return false;
        return true;
      }
      return !!s.el.querySelector('input:checked');
    }

    var cur = -1;
    var first = nextFrom(-1);
    var advTimer = null;
    var backTimer = null;
    var busy = false;
    var done = false;
    var wasComplete = {}; // for „all“ steps (ratings): complete before the latest tap?
    var scoreSent = false; // stage „score“ goes out once per visit (set only once Klaviyo answered 2xx)
    var lastQ = ''; // the last question shown (last_step of a flush while the intro screen shows)
    var otherOk = {}; // „Wofür sonst?“ / „Was genau?“ by step, as confirmed by moving on from it (partials never send unconfirmed text, D-078)

    function refresh() {
      var s = steps[cur];
      if (!s || done) return; // after sending (a textarea's late change event must not bring the count back)
      var isIntro = s.name === 'intro';
      var isLast = nextFrom(cur) === -1;
      // the heading stands above the question only on the one-screen short form with a score (t3/t4b from the mail);
      // without a score the first screen is the 0–10 question alone
      lead.hidden = !(isIntro || (isShort && scored && cur === first));
      if (!busy) {
        nextBtn.textContent = nextBtn.getAttribute(isIntro ? 'data-start-label' : (isLast ? 'data-submit-label' : 'data-next-label'));
      }
      // tap questions: „Weiter“ only once something is chosen (and not while the step is about to move on). Ratings
      // (auto „all“): as soon as one row is set, so a partial answer can be kept („Überspringen“ clears the step).
      var picked = !!(s.el && s.el.querySelector('input:checked'));
      nextBtn.classList.toggle('is-idle', !!s.auto && (!picked || !!advTimer));
      var p = prevFrom(cur);
      // „Zurück“ in the top row, in place of the eyebrow (29 Oct): never back to the intro, not while sending
      prevBtn.hidden = busy || p === -1 || steps[p].name === 'intro';
      // short form, last question: „Abschicken“ with an empty field already is the skip
      skipBtn.classList.toggle('is-off', isShort && isLast);
      nav.hidden = isIntro || skipBtn.classList.contains('is-off');
      // also on the first screen when there is no intro (t3/t4b without s: the 0–10 question, whose answer is saved)
      privacy.hidden = !(isIntro || isLast || (cur === first && !exists('intro')));
      var total = numbered.length;
      var n = isIntro ? 0 : number(s.name);
      var showProgress = !isIntro && total > 1 && n > 0;
      track.hidden = !showProgress;
      count.textContent = showProgress ? pattern.replace('[i]', String(n)).replace('[n]', String(total)) : '';
      bar.style.width = showProgress ? Math.round((n / total) * 100) + '%' : '0';
    }

    function go(i, how) {
      // how: 'init' (first screen: no focus move, no history entry), 'history' (from popstate: no new entry)
      cancelAdvance();
      hideError();
      cur = i;
      if (steps[i].name !== 'intro') lastQ = steps[i].name;
      // with s, the 0–10 question opens with the link's score chosen (again after an „Überspringen“ there, which keeps
      // the link's score)
      if (steps[i].name === 'nps' && npsBack && one('nps') === null) {
        var cell = form.querySelector('input[name="nps"][value="' + score + '"]');
        if (cell) cell.checked = true;
      }
      steps.forEach(function (s, j) { if (s.name !== 'intro') s.el.hidden = j !== i; });
      refresh();
      if (how === 'init') return;
      var s = steps[i];
      var el = s.name === 'intro' ? lead : s.el;
      el.classList.remove('fb__step--in');
      void el.offsetWidth; // restart the fade (none with prefers-reduced-motion, see the CSS)
      el.classList.add('fb__step--in');
      toTop();
      focusEl(s.name === 'intro' ? heading : el.querySelector('[data-fb-focus]'));
      if (how !== 'history') histPush(s.name);
    }
    function next() {
      cancelAdvance();
      if (busy || done) return;
      if (steps[cur] && steps[cur].name === 'nps') sendPageScore();
      trySendScore(false); // a failed score goes out again first (same unique_id)
      var j = nextFrom(cur);
      if (j === -1) { finish(); return; }
      var left = steps[cur] ? steps[cur].name : 'intro';
      if (left === 'uses' || left === 'reorder_barriers') otherOk[left] = otherText(left, false);
      go(j);
      if (left !== 'intro') sendPartial('step', left, false);
    }
    function back() {
      cancelAdvance();
      if (busy || done) return;
      var p = prevFrom(cur);
      if (p === -1 || steps[p].name === 'intro') return;
      if (hist && depth > 0) {
        // the browser's own back: popstate shows the previous question; fall back if it never comes
        clearTimeout(backTimer);
        backTimer = setTimeout(function () { go(p, 'history'); }, 600);
        window.history.back();
        return;
      }
      go(p, 'history');
    }
    function skip() {
      if (busy || done) return;
      var s = steps[cur];
      if (s && s.el && s.name !== 'intro') {
        each(s.el.querySelectorAll('input:checked'), function (el) { el.checked = false; });
        each(s.el.querySelectorAll('input[type="text"], textarea'), function (el) { el.value = ''; });
      }
      update();
      next();
    }
    function scheduleAdvance() {
      cancelAdvance();
      var at = cur;
      advTimer = setTimeout(function () {
        advTimer = null;
        if (cur === at) next();
      }, ADVANCE_MS);
      refresh();
    }
    function cancelAdvance() {
      if (advTimer) { clearTimeout(advTimer); advTimer = null; }
    }

    function update() {
      // „Noch gar nicht“ excludes every other use (see the change handler), „Etwas anderes“ opens its field (uses and
      // reorder barriers: data-fb-other names the checkbox group)
      each(form.querySelectorAll('[data-fb-other]'), function (el) {
        el.hidden = values(el.getAttribute('data-fb-other')).indexOf('anderes') === -1;
      });
      steps.forEach(function (s) { if (s.auto === 'all') wasComplete[s.name] = answered(s); });
      if (cur >= 0) refresh();
    }

    // ---------------------------------------------------------------- browser history (back keeps the answers)
    var hist = false;
    var depth = 0; // how many of our entries lie before the current one
    function stateCopy() {
      var out = {};
      var st = null;
      try { st = window.history.state; } catch (e) {}
      if (st && typeof st === 'object') {
        for (var key in st) if (has(st, key)) out[key] = st[key]; // keeps adtFb (the identifiers) in every entry
      }
      return out;
    }
    function histInit(name) {
      if (designMode || !window.history || typeof window.history.pushState !== 'function') return;
      try {
        var st = stateCopy();
        depth = typeof st.fbDepth === 'number' && st.fbDepth > 0 ? st.fbDepth : 0; // a reload keeps its place
        st.fbStep = name;
        st.fbDepth = depth;
        window.history.replaceState(st, '', window.location.href);
        hist = true;
      } catch (e) { hist = false; }
    }
    function histPush(name) {
      if (!hist) return;
      try {
        var st = stateCopy();
        depth += 1;
        st.fbStep = name;
        st.fbDepth = depth;
        window.history.pushState(st, '', window.location.href); // same URL: nothing new for analytics or pixels
      } catch (e) { hist = false; }
    }
    window.addEventListener('popstate', function (e) {
      if (!hist) return;
      var st = e.state;
      if (!st || typeof st.fbStep !== 'string') return;
      clearTimeout(backTimer);
      depth = typeof st.fbDepth === 'number' ? st.fbDepth : 0;
      if (done || busy) return; // after sending, the thank-you stays
      var i = indexOf(st.fbStep);
      if (i === -1) return;
      // with s, the intro's entry stands for the 0–10 question once a question shows: browser back from the first
      // question goes where „Zurück“ goes (the intro is not shown again)
      if (npsBack && st.fbStep === 'intro' && steps[cur] && steps[cur].name !== 'intro') i = indexOf('nps');
      if (!applies(i, true)) i = prevFrom(i) !== -1 ? prevFrom(i) : first;
      go(i, 'history');
    });

    // ---------------------------------------------------------------- input
    var pointerAt = 0;
    var keyAt = 0;
    var lastKey = '';
    ['pointerdown', 'touchstart', 'mousedown'].forEach(function (type) {
      form.addEventListener(type, function () { pointerAt = Date.now(); lastKey = ''; }, true);
    });

    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name === 'uses' && t.checked) {
        // „Noch gar nicht“ excludes every other use, and the other way round
        each(form.querySelectorAll('input[name="uses"]'), function (el) {
          if (el !== t && (t.value === 'noch_nicht' || el.value === 'noch_nicht')) el.checked = false;
        });
      }
      update();
      hideError();
    });

    // Auto-advance on a tap (or Space) on a radio of a tap question. Arrow keys only move the choice (browsers fire
    // a click for them too, hence the pointer/key check); a second tap on the chosen answer moves on as well.
    form.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || t.tagName !== 'INPUT' || t.type !== 'radio') return;
      var s = steps[cur];
      if (!s || !s.auto || !s.el.contains(t)) return;
      var now = Date.now();
      var byPointer = now - pointerAt < 1500;
      var bySpace = (lastKey === ' ' || lastKey === 'Spacebar') && now - keyAt < 1500;
      if (!byPointer && !bySpace) return;
      if (s.auto === 'all' && (!answered(s) || wasComplete[s.name])) return; // ratings: move on when the last row is set
      scheduleAdvance();
    });

    form.addEventListener('keydown', function (e) {
      var t = e.target;
      lastKey = e.key || '';
      keyAt = Date.now();
      pointerAt = 0;
      if (!(e.key === 'Enter' || e.keyCode === 13) || !t) return;
      if (t.tagName === 'TEXTAREA' || t.tagName === 'BUTTON' || t.tagName === 'A') return;
      // Return/„Fertig“ in the one-line „Wofür sonst?“ field only closes the keyboard (check 26 Oct 2026: it must
      // never send a half-filled form); focus goes to „Weiter“, so keyboard and screen-reader users keep their place
      if (t.tagName === 'INPUT' && t.type === 'text') {
        e.preventDefault();
        try { nextBtn.focus(); } catch (err) {}
        if (document.activeElement === t) { try { t.blur(); } catch (err) {} }
        return;
      }
      if (t.tagName === 'INPUT' && (t.type === 'radio' || t.type === 'checkbox')) {
        e.preventDefault();
        var s = steps[cur];
        if (t.type === 'radio' && !t.checked && s && s.auto === 'one') {
          t.checked = true;
          try { t.dispatchEvent(new Event('change', { bubbles: true })); } catch (err) { update(); }
          scheduleAdvance();
          return;
        }
        next();
      }
    });
    // No implicit submission: the stepper sends once, at the end (finish)
    form.addEventListener('submit', function (e) { e.preventDefault(); });

    nextBtn.addEventListener('click', function () { if (!busy) next(); });
    prevBtn.addEventListener('click', back);
    skipBtn.addEventListener('click', skip);

    // ---------------------------------------------------------------- sending
    function post(stage, extra, keepalive) {
      var props = { stage: stage, response_id: responseId, form_version: cfg.formVersion, src: src };
      if (order) props.order_reference = order;
      for (var key in extra) { if (has(extra, key)) props[key] = extra[key]; }
      var profile = { type: 'profile', attributes: {} };
      if (k) profile.id = k;
      if (kx) profile.attributes._kx = kx;
      var body = {
        data: {
          type: 'event',
          attributes: {
            properties: props,
            metric: { data: { type: 'metric', attributes: { name: cfg.metric } } },
            profile: { data: profile },
            unique_id: responseId + ':' + stage + (stage === 'partial' ? ':' + visitId + ':' + props.seq : '')
          }
        }
      };
      return send(body, keepalive);
    }

    // The only place that talks to Klaviyo. keepalive (the flush when the page is hidden or left): the request may
    // outlive the page, so it gets no timeout signal.
    function send(body, keepalive) {
      if (dryRun) {
        // DRY RUN: nothing leaves the page.
        dryLog.push(body);
        if (window.console) window.console.info('[feedback preview] not sent:', body);
        return Promise.resolve(null);
      }
      if (typeof window.fetch !== 'function') return Promise.reject(new Error('no fetch')); // old browser: the error message
      var ctrl = !keepalive && typeof window.AbortController === 'function' ? new window.AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 15000) : null;
      return window.fetch(ENDPOINT + encodeURIComponent(cfg.company), {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        cache: 'no-store',
        referrerPolicy: 'strict-origin',
        keepalive: !!keepalive,
        headers: {
          'Content-Type': 'application/vnd.api+json',
          'Accept': 'application/vnd.api+json',
          'revision': cfg.revision
        },
        body: JSON.stringify(body),
        signal: ctrl ? ctrl.signal : undefined
      }).then(function (res) {
        if (timer) clearTimeout(timer);
        if (!res.ok) throw new Error('Klaviyo ' + res.status);
        return res;
      }, function (err) {
        if (timer) clearTimeout(timer);
        throw err;
      });
    }

    // Stage „score“: the score from the link, recorded even if nobody answers anything else
    var scoreDue = false; // its moment has come (on screen DWELL_MS, first tap, page load, or leaving the 0–10 question)
    var scoreBusy = false; // its POST is in flight
    var scoreTrigger = ''; // what made it due, sent as trigger: load (no tap or key press) | tap
    var scoreVisibleMs = 0; // how long the page had been on screen at that moment (visible_ms)
    function due(trigger) {
      // the first reason counts and a retry sends it again; only a tap before Klaviyo accepted a „load“ replaces it
      if (scoreSent || (scoreDue && !(trigger === 'tap' && scoreTrigger !== 'tap'))) return;
      scoreDue = true;
      scoreTrigger = trigger;
      scoreVisibleMs = Math.min(3600000, Math.round(visibleMs()));
    }
    function sendScore(trigger, keepalive) {
      if (!scored) return;
      due(trigger);
      trySendScore(!!keepalive);
    }
    // Without s: the 0–10 answer given on the page, recorded once when the visitor moves on from that question, so it
    // is kept even if they stop part-way. Same metric, property names and unique_id (<response_id>:score, …sx); the
    // „complete“ event of the same visit still wins in crm.survey_responses (a changed answer counts from there).
    function sendPageScore() {
      if (scored || one('nps') === null) return;
      due('tap');
      trySendScore(false);
    }
    // FB-v3: scoreSent only after a 2xx (FB-v2 set it before the POST, so a failed score never went out again); a
    // failed one is retried before the next send: the next step, „Abschicken“ or the flush (same unique_id).
    function trySendScore(keepalive) {
      if (!scoreDue || scoreSent || scoreBusy || done || cfg.scoreEvent === 'off') return;
      var props = scored ? { nps: score, nps_from_link: score } : null; // with s always the link's (see npsBack)
      if (!scored) {
        var v = one('nps');
        if (v === null) return;
        props = { nps: parseInt(v, 10) };
      }
      props.trigger = scoreTrigger || 'tap';
      props.visible_ms = scoreVisibleMs;
      scoreBusy = true;
      post('score', props, keepalive).then(function () {
        scoreBusy = false;
        scoreSent = true;
      }, function () {
        scoreBusy = false; // no message: the click in the mail and the final send both carry the score as well
      });
    }
    // A real tap or key press anywhere on the page (link scanners only load and close it) arms the score (settings
    // „interaction“ and „visible“) and the flush below. Events a script dispatches (isTrusted false; some scanners
    // fake taps that way) don't count.
    var interacted = false;
    var kinds = ['pointerdown', 'touchstart', 'keydown'];
    var arm = function (e) {
      if (e && e.isTrusted === false) return;
      kinds.forEach(function (t) { document.removeEventListener(t, arm, true); });
      interacted = true;
      if (cfg.scoreEvent === 'interaction' || cfg.scoreEvent === 'visible') sendScore('tap');
    };
    kinds.forEach(function (t) { document.addEventListener(t, arm, true); });
    if (cfg.scoreEvent === 'load') sendScore('load');

    // Setting „visible“ (30 Oct): the mail's score counts once the page has been on screen for DWELL_MS in all (a tab
    // in front, not a background tab or a prerender), so a visitor who reads „Danke für deine Bewertung.“ and closes
    // the tab is recorded. Not in a browser with signs of automation (see automated): there it waits for a tap. Sent
    // with keepalive, so it still arrives when the tab is closed right after. Same unique_id as a tap would send.
    var dwellTimer = null;
    var dwellOk = cfg.scoreEvent === 'visible' && scored && !automated();
    function armDwell() {
      if (dwellTimer) { clearTimeout(dwellTimer); dwellTimer = null; }
      if (!dwellOk || scoreDue || done || !onScreen()) return; // starts (again) when the page is on screen
      dwellTimer = setTimeout(function () {
        dwellTimer = null;
        if (scoreDue || done) return;
        if (onScreen() && visibleMs() >= DWELL_MS) sendScore('load', true);
        else armDwell();
      }, Math.max(50, DWELL_MS - visibleMs()));
    }
    document.addEventListener('visibilitychange', function () { visTick(); armDwell(); });
    document.addEventListener('prerenderingchange', function () { visTick(); armDwell(); });
    armDwell();

    // Stage „partial“ (FB-v3): the answers so far, so a visitor who stops part-way keeps them. Sent on every step
    // forward (Weiter, Überspringen, a tap that moves on) and by the flush, only with ≥ 1 answered question besides
    // the 0–10 one (that one is the score event's) or a mail score changed on the page (29 Oct: the score event keeps
    // the link's, so only partial and complete carry the new one; see npsOut) and only if the snapshot differs from
    // the last one handed over.
    // One partial in flight at a time; a newer snapshot replaces a queued one. seq counts the partials of this visit.
    var seq = 0;
    var keyOut = ''; // the last snapshot handed over (in flight or sent)
    var keyOk = ''; // the last one Klaviyo accepted
    var partialBusy = false;
    var queued = null;
    function snapshotKey(p) {
      var out = {};
      for (var key in p) { if (has(p, key) && key !== 'seconds_on_page') out[key] = p[key]; }
      return JSON.stringify(out);
    }
    // With s: the nps of the last snapshot handed over (the link's score before any), so a score changed back to the
    // link's still replaces a partial that carried the changed one
    function npsOut() {
      try { return keyOut ? JSON.parse(keyOut).nps : score; } catch (e) { return score; }
    }
    function sendPartial(reason, lastStep, keepalive) {
      if (busy || done) return;
      var p = collect(true);
      if (!p || !(p.answered_count || (scored && (p.nps !== score || npsOut() !== p.nps)))) return;
      var key = snapshotKey(p);
      if (key === keyOut) return;
      keyOut = key;
      p.partial_reason = reason;
      p.last_step = lastStep;
      queued = { props: p, key: key, keepalive: keepalive };
      if (!partialBusy) pump();
    }
    function pump() {
      var q = queued;
      queued = null;
      if (!q) return;
      if (busy || done) { keyOut = keyOk; return; } // „Abschicken“ came first: the complete event carries it all
      partialBusy = true;
      seq += 1;
      q.props.visit_id = visitId;
      q.props.seq = seq;
      post('partial', q.props, q.keepalive).then(function () {
        partialBusy = false;
        keyOk = q.key;
        pump();
      }, function () {
        partialBusy = false;
        if (keyOut === q.key) keyOut = keyOk; // nothing newer queued: the next step or the flush tries again
        pump();
      });
    }

    // Flush (FB-v3): when the page is hidden (tab or app switch, screen off) or left, a pending score first, then the
    // answers so far. Best effort, no UI: keepalive, and never beforeunload/unload (they break the back-forward
    // cache). Only after a real tap or key press (except a score that „visible“ made due and Klaviyo has not yet
    // accepted), and not while „Abschicken“ is sending or after it.
    function firstQ() {
      for (var i = 0; i < steps.length; i++) { if (steps[i].name !== 'intro') return steps[i].name; }
      return '';
    }
    function flush() {
      if (busy || done) return;
      if (!interacted) {
        try { trySendScore(true); } catch (e) {} // sends only if a score is due (setting „visible“) and not yet accepted
        return;
      }
      try {
        if (!scored && one('nps') !== null) due('tap'); // a 0–10 answer the visitor has not moved on from yet
        trySendScore(true);
        var s = steps[cur];
        // lastQ is empty only if the browser restored answers into a fresh page that still shows the intro
        sendPartial('hide', s && s.name !== 'intro' ? s.name : (lastQ || firstQ()), true);
      } catch (e) {}
    }
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') flush();
    });
    window.addEventListener('pagehide', flush);

    // Stage „complete“: once, after the last question
    function hideError() { errorBox.hidden = true; errorBox.textContent = ''; }
    function showError(sel) {
      var msg = form.querySelector(sel);
      errorBox.textContent = msg ? msg.textContent : '';
      errorBox.hidden = false;
    }

    // The „Etwas anderes“ text of a multiple-choice step (uses → uses_other, reorder_barriers → reorder_barriers_other):
    // only while „anderes“ is ticked there; in a partial only as confirmed by moving on from the step (D-078)
    function otherText(step, partial) {
      if (values(step).indexOf('anderes') === -1) return '';
      return partial ? (otherOk[step] || '') : text(step + '_other');
    }

    // partial: the snapshot for stage „partial“ (text typed in the last question, not sent, only with save_unsent_text;
    // „Wofür sonst?“ and „Was genau?“ only as confirmed with Weiter)
    function collect(partial) {
      var p = {};
      var n = 0;
      if (scored) {
        // the 0–10 answer on the page if the visitor went back to it and changed the mail score (npsBack)
        var again = npsBack ? one('nps') : null;
        p.nps = again !== null ? parseInt(again, 10) : score;
        p.nps_from_link = score;
      } else {
        var nps = one('nps');
        if (nps !== null) p.nps = parseInt(nps, 10);
      }
      if (!isShort) {
        var uses = values('uses');
        if (uses.length) { p.uses = uses; n++; }
        var other = otherText('uses', partial);
        if (other) p.uses_other = other;
        if (uses.indexOf('noch_nicht') === -1) {
          var fr = one('frequency');
          if (fr) { p.frequency = fr; n++; }
          var rated = 0;
          ['rating_loesen', 'rating_geschmack', 'rating_dosieren'].forEach(function (name) {
            var v = one(name);
            if (v) { p[name] = parseInt(v, 10); rated++; }
          });
          if (rated) n++; // one question, however many rows are set
        }
        var intent = one('reorder_intent');
        if (intent) { p.reorder_intent = intent; n++; }
        if (intent && intent !== 'ja_sicher') {
          var bars = values('reorder_barriers');
          if (bars.length) { p.reorder_barriers = bars; n++; }
          var why = otherText('reorder_barriers', partial);
          if (why) p.reorder_barriers_other = why; // part of the barriers answer, not a question of its own
        }
        if (indexOf('source_channel') !== -1) {
          var ch = one('source_channel');
          if (ch) { p.source_channel = ch; n++; }
        }
      }
      var t = text('improve_text');
      if (t && (!partial || cfg.saveText)) { p.improve_text = t; n++; }
      if (!has(p, 'nps') && n === 0) return null;
      p.answered_count = n; // answered questions without the 0–10 one
      p.seconds_on_page = Math.min(3600, Math.round((Date.now() - t0) / 1000));
      return p;
    }

    function setBusy(on) {
      busy = on;
      nextBtn.disabled = on;
      prevBtn.disabled = on;
      skipBtn.disabled = on;
      if (on) {
        prevBtn.hidden = true; // back after an error (refresh)
        nextBtn.setAttribute('aria-busy', 'true');
        nextBtn.textContent = nextBtn.getAttribute('data-busy-label');
      } else {
        nextBtn.removeAttribute('aria-busy');
        refresh();
      }
    }
    function thanks() {
      done = true;
      count.textContent = '';
      track.hidden = true;
      prevBtn.hidden = true; // the top row stays: the eyebrow again
      show('thanks');
      toTop();
      focusEl(root.querySelector('[data-fb-state="thanks"] .fb__heading'));
      // step the history back to where the visit started, so one back press leaves the page
      if (hist && depth > 0) { try { window.history.go(-depth); } catch (e) {} }
    }
    function finish() {
      if (busy || done) return;
      var props = collect();
      if (!props) { thanks(); return; } // nothing answered and no score: nothing to save, the thank-you all the same
      props.visit_id = visitId;
      props.seq = seq + 1; // after the last partial of this visit
      setBusy(true);
      hideError();
      post('complete', props).then(function () {
        busy = false;
        thanks();
      }, function () {
        setBusy(false);
        showError('[data-fb-msg-error]'); // a retry sends the same unique_id
      });
    }

    // ---------------------------------------------------------------- start
    update();
    show('form');
    window.__additFeedbackReady = true; // set only once the form shows: a failure before this leaves the fallback timer armed
    setOffset();
    var rz = null;
    window.addEventListener('resize', function () {
      if (rz) return;
      rz = setTimeout(function () { rz = null; setOffset(); }, 150);
    });
    histInit(steps[first].name);
    go(first, 'init');
  }

  // If the stepper cannot start (a template edit removed an element, an old browser), show the section's fallback
  // message at once instead of an empty band
  function safeInit(root) {
    try {
      init(root);
    } catch (err) {
      try {
        each(root.querySelectorAll('[data-fb-state]'), function (el) {
          el.hidden = el.getAttribute('data-fb-state') !== 'fallback';
        });
      } catch (e) {}
      if (window.console) window.console.error('[feedback] could not start:', err);
    }
  }
  function start() { each(document.querySelectorAll('[data-feedback-survey]'), safeInit); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  // Theme editor re-renders the section on every setting change
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector('[data-feedback-survey]');
    if (el) safeInit(el);
  });
})();
